import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from "../../../mixin/mixin.js";


export default {
  mixins: [mixx],
  name: 'liquidaciones',
  data() {
    return {
      msg: '-',
      loading: false,
      tbv: null,
      f_c: {
        desde: this.date_rest(this.currentdate(), -30),
        hasta: this.currentdate()
      }
    }
  },
  mounted: function () {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: ['excelHtml5'],
    });
    $('.box').boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  computed: {
    reporte: function () {
      return (
        "/reportes/resumen/liquidaciones?desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta
      );
    }
  },


  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post(
          "/reportes/resumen/liquidaciones", this.f_c)
        .then(response => {
          if (response.data.status == 1) {
            for (let i = 0; i < response.data.data.length; i++) {

              response.data.data[i][8] = this.num_to_many(response.data.data[i][8]);
              response.data.data[i][9] = this.num_to_many(response.data.data[i][9]);
              response.data.data[i][10] = this.num_to_many(response.data.data[i][10]);
              response.data.data[i][11] = this.num_to_many(response.data.data[i][11]);
              response.data.data[i][12] = this.num_to_many(response.data.data[i][12]);
              response.data.data[i][13] = this.num_to_many(response.data.data[i][13]);
              response.data.data[i][14] = this.num_to_many(response.data.data[i][14]);
              response.data.data[i][15] = this.num_to_many(response.data.data[i][15]);
              response.data.data[i][16] = this.num_to_many(response.data.data[i][16]);
              response.data.data[i][17] = this.num_to_many(response.data.data[i][17]);
              response.data.data[i][18] = this.num_to_many(response.data.data[i][18]);
              response.data.data[i][19] = this.num_to_many(response.data.data[i][19]);
              response.data.data[i][20] = this.num_to_many(response.data.data[i][20]);
              response.data.data[i][21] = this.num_to_many(response.data.data[i][21]);
              response.data.data[i][22] = this.num_to_many(response.data.data[i][22]);
              response.data.data[i][23] = this.num_to_many(response.data.data[i][23]);
              response.data.data[i][24] = this.num_to_many(response.data.data[i][24]);
              response.data.data[i][25] = this.num_to_many(response.data.data[i][25]);
              response.data.data[i][26] = this.num_to_many(response.data.data[i][26]);
              response.data.data[i][27] = this.num_to_many(response.data.data[i][27]);
              response.data.data[i][28] = this.num_to_many(response.data.data[i][28]);
              response.data.data[i][29] = this.num_to_many(response.data.data[i][29]);
              response.data.data[i][30] = this.num_to_many(response.data.data[i][30]);
              response.data.data[i][31] = this.num_to_many(response.data.data[i][31]);
              response.data.data[i][32] = this.num_to_many(response.data.data[i][32]);
              response.data.data[i][33] = this.num_to_many(response.data.data[i][33]);
              response.data.data[i][34] = this.num_to_many(response.data.data[i][34]);
              response.data.data[i][35] = this.num_to_many(response.data.data[i][35]);
              response.data.data[i][36] = this.num_to_many(response.data.data[i][36]);
              response.data.data[i][37] = this.num_to_many(response.data.data[i][37]);
              response.data.data[i][38] = this.num_to_many(response.data.data[i][38]);
              response.data.data[i][39] = this.num_to_many(response.data.data[i][39]);

              this.tbv.row.add(response.data.data[i]);
            }
          }
          this.tbv.draw();
          this.loading = false;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/liquidaciones/index.js